// app/javascript/pages/library.ts

export function initLibrary(): void {
  const container = document.querySelector('[data-controller="library-sort"]');
  if (!container) return;

  const sortSelect = container.querySelector<HTMLSelectElement>(
    "select[name='sort']",
  );

  if (sortSelect) {
    sortSelect.addEventListener("change", () => {
      const form = sortSelect.closest("form");
      if (form) {
        form.submit();
      }
    });
  }
}
